/**
 * Labstep
 *
 * @module components/ResourceLocation/EmptyState/Map
 * @desc Empty state for ResourceLocationMap
 */

import { ResourceLocationActionCreateMap as ResourceLocationMapActionCreate } from 'labstep-web/components/ResourceLocation/Action/CreateMap';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import type React from 'react';
import type { IResourceLocationEmptyStateMapProps } from './types';

export const ResourceLocationEmptyStateMap: React.FC<
  IResourceLocationEmptyStateMapProps
> = (props) => (
  <CardEmptyState
    src="/img/empty-state/locations.svg"
    title="No map"
    explanation="Create a physical map to indicate where items and sublocations sit within this location."
    action={<ResourceLocationMapActionCreate {...props} />}
  />
);
